import { useList, useDetail, useCreate, useUpdate, useDelete, useAction } from "@inmagik/react-crud"
import { Tag } from "../types"
import { API_URL } from "../constants"

export function useTagsList(params: Record<string, string> = {}) {
  return useList<Tag>(`${API_URL}/tags`, {
    query: params,
  })
}

export function useTag(id: number | undefined | string) {
  return useDetail<Tag>(`${API_URL}/tags`, id?.toString())
}

export function useTagCreate() {
  return useCreate<Tag>(`${API_URL}/tags`)
}

export function useTagUpdate() {
  return useUpdate<Tag>(`${API_URL}/tags`)
}

export function useTagDelete() {
  return useDelete<Tag>(`${API_URL}/tags`)
}

export function useUnificaTags() {
  return useAction<void, { vocabolario_da_mantenere: string; vocaboli_da_eliminare: string[] }>(`${API_URL}/tags/unifica`, {
    method: "POST",
  })
}



